<p-toast position="top-right"></p-toast>
<ng-progress ></ng-progress>
<!-- BEGIN HEADER -->
<div class="page-header navbar navbar-fixed-top">
  <!-- BEGIN HEADER INNER -->
  <div class="page-header-inner ">
    <!-- BEGIN LOGO -->
    <div class="page-logo">
      <a *ngIf="brand$ | async as brand" >
        <img width="80"
             [src]="'/assets/images/brands/' + brand.id + '/logo.png'"
             [alt]="brand.name"
             class="logo-default">
      </a>
      <div class="menu-toggler sidebar-toggler" (click)="toggleSidebar()">
        <!-- DOC: Remove the above "hide" to enable the sidebar toggler button on header -->
      </div>
    </div>
    <!-- END LOGO -->
    <!-- BEGIN RESPONSIVE MENU TOGGLER -->
    <span class="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse"> </span>
    <!-- END RESPONSIVE MENU TOGGLER -->
    <!-- BEGIN PAGE TOP -->
    <div class="page-top">

      <span class="caption header-title"  *ngIf="headerTitle$ | async" style="
        width: 59vw;
        overflow:hidden;
        white-space:nowrap;
        text-overflow: ellipsis;">
        <span class="caption-subject" style="font-size: 18px ;">
          <i  class="{{headerTitle.icon}}"></i>&nbsp;
          <span class="bold">{{ headerTitle.title | translate:locale.language}}</span>
        </span>
      </span>
<!--      <div class="top-menu pull-left client-name">-->
<!--        <h3>{{ 'SITE_TITLE' | translate:lang }}</h3>-->
<!--      </div>-->


<!--      <div *ngFor="let bc of bcData$ | async">-->
<!--          <div [ngSwitch]="bc.type" >-->
<!--              <storever-bread-crumb-client-->
<!--                *ngSwitchCase="'client'"-->
<!--                [data]="bc"-->
<!--              ></storever-bread-crumb-client>-->

<!--              <storever-bread-crumb-order-->
<!--                *ngSwitchCase="'order'"-->
<!--                [data]="bc"-->
<!--              ></storever-bread-crumb-order>-->

<!--            <storever-bread-crumb-site-->
<!--              *ngSwitchCase="'site'"-->
<!--              [data]="bc"-->
<!--            ></storever-bread-crumb-site>-->
<!--            <storever-bread-crumb-report-->
<!--              *ngSwitchCase="'report'"-->
<!--              [data]="bc"-->
<!--            ></storever-bread-crumb-report>-->

<!--              <span *ngSwitchDefault></span>-->
<!--          </div>-->
<!--      </div>-->
<!--      <div *ngIf="breadCrumbSearch((breadCrumb$|async) , '4')">-->
<!--        <storever-bread-crumb-->
<!--          [tooltipText]="'GENERIC_REPORTS'"-->
<!--          [icon]="'fad fa-file-contract'"-->
<!--          [myData]="myReport"-->
<!--          [type]="'report'"-->
<!--        ></storever-bread-crumb>-->
<!--      </div>-->

      <storever-top-menu [userInfo]="userInfo$ | async"
                         [canImpersonate]="isInRole$('RUNAS') | async"
                         [canUseQuickSearch]="isInRole$('BO_QUICKSEARCH') | async"
                         [impersonatedUser]="impersonatedUser$ | async"
                         [availableLanguages]="availableLanguages"
                         [currentLanguage]="'en'"
                         (impersonate)="impersonate($event, impersonateUserDialog)"
                         (logout)="logout()"
                         (selectLanguage)="selectLanguage($event)"></storever-top-menu>

    </div>
    <!-- END PAGE TOP -->
  </div>
  <!-- END HEADER INNER -->
</div>
<!-- END HEADER -->
<!-- BEGIN HEADER & CONTENT DIVIDER -->
<div class="clearfix"></div>
<!-- END HEADER & CONTENT DIVIDER -->
<!-- BEGIN CONTAINER -->
<div class="page-container">
  <!-- BEGIN SIDEBAR -->
  <div class="page-sidebar-wrapper">
    <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
    <!-- DOC: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
    <div class="page-sidebar navbar-collapse collapse" style="z-index: 1000;">
      <!-- BEGIN SIDEBAR MENU -->
      <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
      <!-- DOC: Apply "page-sidebar-menu-hover-submenu" class right after "page-sidebar-menu" to enable hoverable(hover vs accordion) sub menu mode -->
      <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
      <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
      <!-- DOC: Set data-keep-expand="true" to keep the submenues expanded -->
      <!-- DOC: Set data-auto-speed="200" to adjust the sub menu slide up/down speed -->
      <ul class="page-sidebar-menu page-header-fixed page-sidebar-menu-hover-submenu page-sidebar-menu-closed"
          data-keep-expanded="false"
          data-auto-scroll="true"
          data-slide-speed="200">
        <!--<li class="nav-item start" [routerLinkActive]="['active', 'open']">-->
          <!--<a [routerLink]="dashboardLink$ | async" class="nav-link nav-toggle">-->
            <!--<i class="fal fa-home"></i>-->
            <!--<span class="title" translate>DASHBOARD</span>-->
            <!--<span [class.arrow]="!isRouteActive(['/', clientId, 'dashboard'])" [class.selected]="isRouteActive(['/', clientId, 'dashboard'])"></span>-->
          <!--</a>-->
        <!--</li>-->
        <li class="nav-item start" [routerLinkActive]="['active', 'open']"  *ngIf="isInRole$('BO_CLIENT_VIEW') | async">
          <a [routerLink]="clientLink$ | async" class="nav-link nav-toggle">
            <i class="fal fa-user"></i>
            <span class="title">{{'GENERIC_CLIENTS' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'clients', 'list'])" [class.selected]="isRouteActive(['/', 'clients', 'list'])"></span>
          </a>
        </li>
        <li class="nav-item start" *ngIf="isInRole$('BO_ORDER_VIEW') | async" [routerLinkActive]="['active', 'open']">
          <a [routerLink]="ordersLink$ | async" class="nav-link nav-toggle">
            <i class="far fa-shopping-cart"></i>
            <span class="title">{{'GENERIC_ORDERS' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'orders'])" [class.selected]="isRouteActive(['/', 'orders'])"></span>
          </a>
        </li>
        <li  *ngIf="isInRole$('BO_BILLING_VIEW') | async"  class="nav-item start" [routerLinkActive]="['active', 'open']">
          <a [routerLink]="companiesLink$ | async" class="nav-link nav-toggle">
            <i class="fal fa-city"></i>
            <span class="title">{{'GENERIC_COMPANIES' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'companies'])" [class.selected]="isRouteActive(['/','companies', 'list'])"></span>
          </a>
        </li>
        <li  *ngIf="(isInRole$('BO_ANOMALIES_VIEW') | async) ||
                    (isInRole$('BO_BILLING_INVOICES_VIEW') | async) ||
                    ((isInRole$('BO_INTERNAL_USER') | async) &&
                    (isInRole$('BO_SETUP') | async))"

             class="nav-item start" [routerLinkActive]="['active', 'open']">
          <a [routerLink]="anomaliesLink$ | async"   class="nav-link nav-toggle" >
            <i class="fal fa-exclamation-triangle"></i>
            <span class="title">{{'GENERIC_ANOMALIES' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'anomalies'])" [class.selected]="isRouteActive(['/','anomalies', 'list'])"></span>
          </a>
        </li>
        <li  *ngIf="isInRole$('BO_SHIPPING_VIEW') | async"  class="nav-item start" [routerLinkActive]="['active', 'open']">
          <a [routerLink]="shippingsLink$ | async" class="nav-link nav-toggle">
            <i class="fal fa-shipping-fast"></i>
            <span class="title">{{'GENERIC_SHIPPINGS' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'shippings'])" [class.selected]="isRouteActive(['/','shippings', 'list'])"></span>
          </a>
        </li>
        <li  *ngIf="isInRole$('BO_BILLING_INVOICES_VIEW') | async"  class="nav-item start" [routerLinkActive]="['active', 'open']">
          <a [routerLink]="invoicesLink$ | async" class="nav-link nav-toggle">
<!--            <i class="fas fa-wallet"></i>-->
            <i class="fas fa-file-invoice-dollar"></i>
            <span class="title">{{'GENERIC_INVOICES' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'invoices'])" [class.selected]="isRouteActive(['/','invoices', 'list'])"></span>
          </a>
        </li>
        <li class="nav-item start" *ngIf="isInRole$('BO_BILLING_SALES_DASHBOARD_VIEW') | async"  [routerLinkActive]="['active', 'open']">
          <a [routerLink]="dashboardLink$ | async" class="nav-link nav-toggle">
            <i class="fal fa-tachometer"></i>
            <span class="title">{{'DASHBOARD_LINK' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'dashboard', 'sales'])" [class.selected]="isRouteActive(['/','dashboard', 'sales'])"></span>
          </a>
        </li>
        <li class="nav-item start" *ngIf="isInRole$('BO_REPORTING_VIEW') | async" [routerLinkActive]="['active', 'open']">
          <a [routerLink]="reportsLink$ | async" class="nav-link nav-toggle">
            <i class="fal fa-file-contract"></i>
            <span class="title">{{'GENERIC_REPORTS' | translate:locale.language}}</span>
            <span [class.arrow]="!isRouteActive(['/', 'reports', 'page'])" [class.selected]="isRouteActive(['/','reports', 'page'])"></span>
          </a>
        </li>
        <li *ngIf="(hasExternalLinks$ | async) && (isInRole$('BO_MORE_APPS_VIEW') | async)" class="nav-item">
          <a href="javascript:;" class="nav-link nav-toggle">
            <i class="fal fa-ellipsis-v"></i>
            <span class="title">{{'EXTERNAL_APPS' | translate:locale.language}}</span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
            <li *ngFor="let link of externalLinks$ | async" class="nav-item">
              <a [href]="link.url" target="_blank" rel="noreferrer noopener" class="nav-link">
                <span class="title">{{link.name}}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <!-- END SIDEBAR MENU -->
    </div>
  </div>
  <!-- END SIDEBAR -->

  <!-- BEGIN CONTENT -->
  <div class="page-content-wrapper">
    <!-- BEGIN CONTENT BODY -->
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
    <!-- END CONTENT BODY -->
  </div>
  <!-- END CONTENT -->
</div>
<!-- END CONTAINER -->
<!-- BEGIN FOOTER -->
<div class="page-footer">
  <div *ngIf="brand$ | async as brand" class="page-footer-inner">
    {{copyrightYear}} &copy; <a href="http://mcubedigital.com" target="_blank" rel="noreferrer noopener">{{brand.name}}</a>
    <storever-scroll-to-top [isVisible]="scrollToTopVisible"></storever-scroll-to-top>
  </div>
  <div class="page-footer-inner version">
    <span>v{{currentApplicationVersion}}</span>
  </div>
  <div id="container">
    <span><a href="https://portal.mcubedigital.com/privacy-policy" target="_blank" fragment="privacy-policy" title="" rel="license">{{'PRIVACY_POLICY' | translate:locale.language}}</a></span>
    <span><a href="https://portal.mcubedigital.com/terms-of-use"  target="_blank" fragment="terms-of-use" title="" rel="license">{{'TERMS_OF_USE' | translate:locale.language}}</a></span>
  </div>
</div>
<!-- END FOOTER -->
<storever-block-ui></storever-block-ui>
<storever-impersonate-user #impersonateUserDialog
                           [users]="impersonableUsers$ | async"
                           (impersonate)="impersonateUser($event)"
                           (reload)="reloadImpersonableUsers()"></storever-impersonate-user>

<storever-quick-search-results [results]="quickSearchResults$ | async"
[count]="quickSearchResultsCount$ | async"
[currentPage]="quickSearchResultsPage$ | async"
[itemsPerPage]="quickSearchResultsPageSize$ | async"
[orderBy]="quickSearchResultsOrderBy$ | async"
[showModal]="showQuickSearchResults$ | async"
[pattern]="quickSearchResultsPattern$ | async"
(pageChanged)="quickSearchPageChanged($event)"
(pageSizeChanged)="quickSearchPageSizeChanged($event)"
(orderByChanged)="quickSearchOrderByChanged($event)"
(close)="closeQuickSearchResults()"
(gotoPlayer)="gotoPlayer($event)"></storever-quick-search-results>

